import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class InstructionsScene implements Scene {
  readonly id = "instructions" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.hideHud();
    this.ui.show("instructions");
  }
  exit(): void {}
}
